import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { getStorage } from '@/utils/storage';
import { $http } from '@/axios';

// 查询当前企业已授权的品牌列表
export const queryAuthBrandPage: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAuthBrandPage', { ...state.authBrandPage, loading: true });
    const orgId = JSON.parse(getStorage('orgInfo') || '{}').id;
    const res: IPageData = await $http.post('/v1/data/system/org/authbrands', { ...payload, orgId });
    const { list: data, pageNum, pageSize, total } = res;
    commit('setAuthBrandPage', { data, pageNum, pageSize, total });
  } catch (e) {
    commit('setAuthBrandPage', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查询指定品牌下已授权的企业列表
export const queryAuthOrgPage: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAuthOrgPage', { ...state.authOrgPage, loading: true });
    const res: IPageData = await $http.post('/v1/baseinfo/brand/authorglist', payload);
    const { list: data, pageNum, pageSize, total } = res;
    commit('setAuthOrgPage', { data, pageNum, pageSize, total });
  } catch (e) {
    commit('setAuthOrgPage', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 检测当前企业是否有owner品牌且是私有品牌
export const checkOwnerBrand: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setHasOwnerBrand', false);
    const orgId = JSON.parse(getStorage('orgInfo') || '{}').id;
    const params = { orgId, owner: true, isPrivateBrand: true };
    const res: any[] = await $http.post('/v1/data/system/org/authbrandlist', params);
    commit('setHasOwnerBrand', !!res.length);
  } catch (e) {
    commit('setHasOwnerBrand', false);
  }
};

// 删除组织和私有品牌的授权关系
export const deleteOrgAuth: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/system/org/cancelbrandauth', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
